import React from "react";
// import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";

export default function SplitterImgBox({ BeforeImg, AfterImg, label, extraClassName }) {
    return (
        <>
            <div className={"relative " + extraClassName}>
                <ReactCompareSlider
                    className="border-round-xl"
                    style={{ height: "400px" }}
                    itemOne={<ReactCompareSliderImage src={BeforeImg} alt="before" />}
                    itemTwo={<ReactCompareSliderImage src={AfterImg} alt="after" />}
                />
                {label ? (
                    <>
                        <div className="absolute label-spiltter text-green z-2 border-round-xl bg-white px-3 py-1 rounded">Before</div>
                        <div className="absolute label-spiltter text-green z-2 border-round-xl bg-white px-3 py-1 rounded">After</div>{" "}
                    </>
                ) : null}
            </div>
        </>
    );
}
